import { useState } from "react";

export function CodeSnippet({
  code,
  label,
}: {
  code: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="mt-2 bg-neutral-50 text-content-primary rounded border border-border-primary overflow-hidden">
      <div className="flex items-center justify-between px-3 py-1.5 bg-neutral-100 border-b border-border-primary text-xs">
        <span className="text-content-secondary">{label ?? "snippet"}</span>
        <button
          type="button"
          onClick={handleCopy}
          className="text-content-secondary hover:text-content-primary transition-colors"
        >
          {copied ? "✓ Copied" : "Copy"}
        </button>
      </div>
      <pre className="p-3 text-xs overflow-x-auto whitespace-pre font-mono leading-relaxed text-content-primary">
        {code}
      </pre>
    </div>
  );
}
